<div class="container">
  <h3 class="page-title">Novo procedimento</h3>
  <mc-exam-template-form
      [template]="template"
      [examGroups]="examGroups"
      (canceled)="goBack()"
      (saved)="save()">
  </mc-exam-template-form>
</div>